export default __webpack_public_path__ + "static/media/headerPicksBanner.423c30c9.png";